import React from 'react';
import RequestDayList from './RequestDayList';
import MatchPanel from './MatchPanel';
import { formatTime, mailtoAddress, requestLocation } from './requestFormat';

// DJB-265/279: Song Requests — the year › month › day tree with a card per
// request. The café groups of DJB-265 are gone: the location is on the card
// ("Requested at: {café} - {gemeente} ({uu:mm:ss})"). Reused as the Song
// Requests section under Library › Upload (DJB-269).

export const REPLY_SUBJECT = 'Uw aanvraag op de jukebox is verwerkt';

// The place as it reads in the reply: "{machineName} {machineCity}" for a
// known jukebox, otherwise the café the visitor typed
const replyPlace = (item) =>
  item.machineName ? [item.machineName, item.machineCity].filter(Boolean).join(' ') : item.cafe || '';

export const replyBody = (item) =>
  `Beste,\n\nBedankt voor uw suggestie. Vanaf nu kan je "${item.titel} - ${item.artiest}" vinden op uw favoriete jukebox in ${replyPlace(item)}.\n\nVriendelijke groeten,\nDigitale Jukebox`;

// mailto: for the "reply" pill; everything URL-encoded so visitor text can
// neither break the link nor add headers. Replying does NOT complete the
// request — that stays a separate click on Mark as Done.
export const songReplyMailto = (item) =>
  `mailto:${mailtoAddress(item.email)}?subject=${encodeURIComponent(REPLY_SUBJECT)}&body=${encodeURIComponent(replyBody(item))}`;

export const SongRequestContent = ({ item }) => (
  <>
    <h5 className="request-card-title">{`${item.titel} - ${item.artiest}`}</h5>
    <p className="request-card-line">
      <span className="request-card-label">Requested at:</span>
      <span className="request-card-value">{`${requestLocation(item) || 'Unknown'} (${formatTime(item.createdAt)})`}</span>
    </p>
    <p className="request-card-line">
      <span className="request-card-label">Requested by:</span>
      <span className="request-card-value">
        {item.email ? (
          <>
            <a className="request-link" href={songReplyMailto(item)}>
              {item.email}
            </a>
            <a className="request-reply-pill" href={songReplyMailto(item)}>
              reply
            </a>
          </>
        ) : (
          'Unknown'
        )}
      </span>
    </p>
  </>
);

// The status box of an open card is the match panel (DJB-266); tests may
// swap it through `renderAside`
const defaultAside = (item) => <MatchPanel item={item} />;

const SongRequestList = ({ status, onChanged, today, renderAside = defaultAside }) => (
  <RequestDayList
    kind="songs"
    status={status}
    onChanged={onChanged}
    today={today}
    renderCard={(item) => ({
      content: <SongRequestContent item={item} />,
      aside: renderAside(item),
    })}
  />
);

export default SongRequestList;
